import { Icon } from '@chakra-ui/react';

export default function SFExclamationMarkTriangleFilled(props) {
  return (
    <Icon
      width={18}
      height={4}
      viewBox='0 0 18 16'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M2.94531 15.7422C1.61719 15.7422 0.8125 14.8203 0.8125 13.625C0.8125 13.2578 0.90625 12.8828 1.11719 12.5312L7.17969 1.96875C7.57812 1.25781 8.28125 0.898438 9 0.898438C9.71875 0.898438 10.4141 1.25781 10.8203 1.96875L16.8828 12.5312C17.0781 12.875 17.1875 13.2578 17.1875 13.625C17.1875 14.8203 16.3828 15.7422 15.0547 15.7422H2.94531ZM9.00781 10.5234C9.39062 10.5234 9.61719 10.2969 9.625 9.875L9.74219 5.63281C9.75 5.21875 9.42188 4.91406 9 4.91406C8.5625 4.91406 8.25781 5.21094 8.26562 5.625L8.36719 9.875C8.375 10.2891 8.60156 10.5234 9.00781 10.5234ZM9.00781 13.1406C9.46875 13.1406 9.875 12.7734 9.875 12.3047C9.875 11.8281 9.47656 11.4609 9.00781 11.4609C8.53125 11.4609 8.13281 11.8359 8.13281 12.3047C8.13281 12.7656 8.53906 13.1406 9.00781 13.1406Z' />
    </Icon>
  );
}
